import { useOutletContext } from "react-router-dom";
import { UwContext } from "./types";

const useUwContext = () => useOutletContext<UwContext>();

export { useUwContext };
